import { render, staticRenderFns } from "./CredenciamentoAtualizacaoAcoesPublicar.vue?vue&type=template&id=af826788"
import script from "./CredenciamentoAtualizacaoAcoesPublicar.vue?vue&type=script&lang=js"
export * from "./CredenciamentoAtualizacaoAcoesPublicar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports